(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_benefits-section_dos"] && !Shopify.designMode) return;
  try {
    
  /* =============================================
     JS ENCAPSULADO CON REVELADOR DE SCROLL GSAP (OPT-IN)
     ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.gem-features-section');
    if (!section) return;

    const animEnabled = section.dataset.animate === 'true';
    const cards = section.querySelectorAll('.gem-gsap-card');
    const isMobile = window.matchMedia("(max-width: 991px)").matches;

    // Guard Clause defensivo: ¿Está GSAP & ScrollTrigger cargado en theme.liquid?
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      const ctx = gsap.context(() => {
        // Ejecutar MatchMedia para respetar accesibilidad de movimiento reducido
        const mm = gsap.matchMedia();

        mm.add({
          reduceMotion: "(prefers-reduced-motion: reduce)",
          animate: "(prefers-reduced-motion: no-preference)"
        }, (context) => {
          if (context.conditions.reduceMotion) return; // Retorno inmediato si prefiere accesibilidad plana

          // 1. ANIMACIÓN DE ENTRADA AL DESPLAZARSE (SCROLL)
          if (animEnabled) {
            gsap.from(cards, {
              scrollTrigger: {
                trigger: section,
                start: "top 85%", // Dispara la revelación un poco antes
                toggleActions: "play none none none"
              },
              opacity: 0,
              y: 60, // Sube progresivamente 60px para dar sensación de elevación fluida
              rotation: (i) => i % 2 === 0 ? -2 : 2, // Rotación gótica alterna
              duration: 0.9,
              stagger: 0.15,
              ease: "back.out(1.2)",
              clearProps: "all"
            });
          }

          // 2. DETECCIÓN ACTIVA DE CENTRO DE PANTALLA EN MÓVILES (HOVER EMULADO)
          // Se activa solo en pantallas móviles/tablets para no interferir con el hover de desktop
          cards.forEach(card => {
            ScrollTrigger.create({
              trigger: card,
              start: "top 60%", // Entra en zona activa cuando cruza el 60% superior de la pantalla
              end: "bottom 40%", // Sale de zona activa al pasar del 40% superior
              toggleClass: { targets: card, className: "is-active-center" },
              invalidateOnRefresh: true
            });
          });

        });
      }, section);

      // Desconexión segura de triggers si Shopify Theme Editor vuelve a renderizar la sección
      section.addEventListener('shopify:section:unload', () => ctx.revert());

    } else {
      // =============================================
      // FALLBACK NATIVO SIN DEPENDENCIAS (INTERSECTION OBSERVER)
      // =============================================
      
      // Fallback de animación de entrada
      if (animEnabled) {
        const entranceObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry, idx) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
              }, idx * 100);
              entranceObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });

        cards.forEach((card, i) => {
          card.style.opacity = '0';
          card.style.transform = 'translateY(40px)';
          card.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
          entranceObserver.observe(card);
        });
      }

      // Fallback de tarjeta activa en el centro para móviles
      if (isMobile) {
        const mobileObserverOptions = {
          root: null,
          rootMargin: "-30% 0px -30% 0px", // Define la franja central activa del viewport del móvil (40% central)
          threshold: 0.1
        };

        const mobileObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-active-center');
            } else {
              entry.target.classList.remove('is-active-center');
            }
          });
        }, mobileObserverOptions);

        cards.forEach(card => mobileObserver.observe(card));
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_faq-section"] && !Shopify.designMode) return;
  try {
    
/* =============================================
   LOGICA OPERACIONAL DE ACORDEÓN COMPLETO (JS)
   ============================================= */
document.addEventListener('DOMContentLoaded', () => {

  const initFaqSection = (wrapper) => {
    const triggers = wrapper.querySelectorAll('.gem-faq-trigger');
    const singleExpand = wrapper.dataset.singleExpand === 'true';

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.gem-faq-item');
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        const contentId = trigger.getAttribute('aria-controls');
        const content = wrapper.querySelector('#' + contentId);

        if (!content) return;

        // Auto-colapsar otros paneles activos si la opción está activa
        if (singleExpand && !isExpanded) {
          triggers.forEach(otherTrigger => {
            if (otherTrigger !== trigger) {
              otherTrigger.setAttribute('aria-expanded', 'false');
              const otherContent = wrapper.querySelector('#' + otherTrigger.getAttribute('aria-controls'));
              if (otherContent) {
                otherContent.style.maxHeight = '0px';
                otherContent.style.opacity = '0';
              }
              const otherItem = otherTrigger.closest('.gem-faq-item');
              if (otherItem) {
                otherItem.classList.remove('is-active');
              }
            }
          });
        }

        // Toggle del acordeón clickeado
        if (isExpanded) {
          trigger.setAttribute('aria-expanded', 'false');
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
          item.classList.remove('is-active');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
          content.style.opacity = '1';
          item.classList.add('is-active');
        }
      });
    });

    // Recalcular el tamaño dinámico del scrollHeight al redimensionar pantalla
    window.addEventListener('resize', () => {
      triggers.forEach(trigger => {
        if (trigger.getAttribute('aria-expanded') === 'true') {
          const content = wrapper.querySelector('#' + trigger.getAttribute('aria-controls'));
          if (content) {
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        }
      });
    });

    // Soporte integrado opcional para animaciones GSAP
    const animateEntry = wrapper.dataset.animateEntry === 'true';
    if (animateEntry && typeof gsap !== 'undefined') {
      const items = wrapper.querySelectorAll('.gem-faq-item');
      const header = wrapper.querySelector('.gem-faq-header');

      const ctx = gsap.context(() => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: wrapper,
            start: 'top 85%',
            toggleActions: 'play none none none'
          }
        });

        if (header) {
          tl.from(header, {
            y: 30,
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out'
          });
        }

        if (items.length > 0) {
          tl.from(items, {
            y: 40,
            opacity: 0,
            stagger: 0.1,
            duration: 0.6,
            ease: 'back.out(1.2)'
          }, '-=0.3');
        }
      }, wrapper);

      wrapper.addEventListener('shopify:section:unload', () => ctx.revert());
    }
  };

  // Inicializar en todas las instancias de la página
  document.querySelectorAll('.gem-faq-wrapper').forEach(wrapper => {
    initFaqSection(wrapper);
  });

  // Escucha del ciclo de vida del Editor de Temas de Shopify (Shopify Theme Editor OS 2.0)
  document.addEventListener('shopify:section:load', (event) => {
    const sectionWrapper = event.target.querySelector('.gem-faq-wrapper');
    if (sectionWrapper) {
      initFaqSection(sectionWrapper);
    }
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_footer-section_dos"] && !Shopify.designMode) return;
  try {
    
  /* =============================================
     JS ENCAPSULADO CON REVELADOR DE SCROLL GSAP (OPT-IN)
     ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const footer = document.querySelector('.gem-footer-section');
    if (!footer) return;

    const animEnabled = footer.dataset.animate === 'true';
    if (!animEnabled) return;

    // Guard Clause defensivo: ¿Está GSAP & ScrollTrigger cargado en theme.liquid?
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      const ctaCard = footer.querySelector('.gem-gsap-cta');
      const columns = footer.querySelectorAll('.gem-gsap-col');
      const lawBanner = footer.querySelector('.gem-gsap-law');

      const ctx = gsap.context(() => {
        const mm = gsap.matchMedia();

        mm.add({
          reduceMotion: "(prefers-reduced-motion: reduce)",
          animate: "(prefers-reduced-motion: no-preference)"
        }, (context) => {
          if (context.conditions.reduceMotion) return;

          // 1. ANIMACIÓN REVEAL DE LA TARJETA CTA
          if (ctaCard) {
            gsap.from(ctaCard, {
              scrollTrigger: {
                trigger: ctaCard,
                start: "top 90%",
                toggleActions: "play none none none"
              },
              opacity: 0,
              y: 50,
              duration: 0.9,
              ease: "power3.out",
              clearProps: "all"
            });
          }

          // 2. STAGGER EN COLUMNAS DE ENLACES
          if (columns.length > 0) {
            gsap.from(columns, {
              scrollTrigger: {
                trigger: ".gem-footer-grid",
                start: "top 90%",
                toggleActions: "play none none none"
              },
              opacity: 0,
              y: 30,
              duration: 0.7,
              stagger: 0.1,
              ease: "power2.out",
              clearProps: "all"
            });
          }

          // 3. ENTRADA DEL BANNER DE LEY COLOMBIANO
          if (lawBanner) {
            gsap.from(lawBanner, {
              scrollTrigger: {
                trigger: lawBanner,
                start: "top 95%",
                toggleActions: "play none none none"
              },
              opacity: 0,
              scaleY: 0.9,
              duration: 0.8,
              ease: "power2.out",
              clearProps: "all"
            });
          }

        });
      }, footer);

      // Limpieza segura en el Editor de Temas de Shopify
      footer.addEventListener('shopify:section:unload', () => ctx.revert());

    } else {
      // Fallback nativo de rendimiento por Intersection Observer
      const elementsToReveal = footer.querySelectorAll('.gem-gsap-cta, .gem-gsap-col, .gem-gsap-law');

      const fallbackObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            fallbackObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      elementsToReveal.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(25px)';
        el.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
        fallbackObserver.observe(el);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_header-section_dos"] && !Shopify.designMode) return;
  try {
    
  /* =============================================
     JS ENCAPSULADO Y RESPONSIVO (DATA-DRIVEN)
     ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const headerWrapper = document.querySelector('.gem-header-outer-container[data-section-id]');
    if (!headerWrapper) return;

    const isSticky = headerWrapper.dataset.sticky === 'true';
    const isTransparent = headerWrapper.dataset.transparent === 'true';
    const isHome = headerWrapper.dataset.template === 'index';

    // 1. Lógica del Carrusel de la Barra de Anuncios
    const announcementBar = headerWrapper.querySelector('.gem-announcement-bar');
    if (announcementBar) {
      const slides = announcementBar.querySelectorAll('.gem-announcement-slide');
      const rotationSpeed = parseInt(announcementBar.dataset.speed, 10) || 4000;
      let currentIndex = 0;

      if (slides.length > 1) {
        setInterval(() => {
          slides[currentIndex].classList.remove('is-active');
          currentIndex = (currentIndex + 1) % slides.length;
          slides[currentIndex].classList.add('is-active');
        }, rotationSpeed);
      }
    }

    // 2. Lógica de Scroll para Sticky e Intersección de Opacidad
    if (isSticky) {
      const handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        
        if (scrollTop > 20) {
          headerWrapper.classList.add('scrolled');
          if (isTransparent && isHome) {
            headerWrapper.classList.remove('is-transparent');
          }
        } else {
          headerWrapper.classList.remove('scrolled');
          if (isTransparent && isHome) {
            headerWrapper.classList.add('is-transparent');
          }
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll(); // Inicializar al cargar
    }

    // 3. Menú Drawer Móvil
    const trigger = headerWrapper.querySelector('.gem-mobile-menu-trigger');
    const drawer = headerWrapper.querySelector('.gem-mobile-drawer');

    if (trigger && drawer) {
      trigger.addEventListener('click', () => {
        const isOpen = trigger.classList.contains('is-active');
        
        trigger.classList.toggle('is-active');
        drawer.classList.toggle('is-active');
        trigger.setAttribute('aria-expanded', !isOpen);
        
        // Deshabilitar scroll del body para evitar fuga de scroll en móvil
        if (!isOpen) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_header-section_tres"] && !Shopify.designMode) return;
  try {
    
  /* =============================================
     JS ENCAPSULADO Y RESPONSIVO (DATA-DRIVEN)
     ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const headerWrapper = document.querySelector('.gem-header-outer-container[data-section-id]');
    if (!headerWrapper) return;

    const isSticky = headerWrapper.dataset.sticky === 'true';
    const isTransparent = headerWrapper.dataset.transparent === 'true';
    const isHome = headerWrapper.dataset.template === 'index';

    // NOTA TÉCNICA: Se ha removido la lógica JS de carrusel de anuncios.
    // Ahora es controlado de forma ultra-eficiente por CSS (Grid / Hardware Marquee Keyframes).

    // 1. Lógica de Scroll para Sticky e Intersección de Opacidad
    if (isSticky) {
      const handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        
        if (scrollTop > 20) {
          headerWrapper.classList.add('scrolled');
          if (isTransparent && isHome) {
            headerWrapper.classList.remove('is-transparent');
          }
        } else {
          headerWrapper.classList.remove('scrolled');
          if (isTransparent && isHome) {
            headerWrapper.classList.add('is-transparent');
          }
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll(); // Inicializar al cargar
    }

    // 2. Menú Drawer Móvil
    const trigger = headerWrapper.querySelector('.gem-mobile-menu-trigger');
    const drawer = headerWrapper.querySelector('.gem-mobile-drawer');

    if (trigger && drawer) {
      trigger.addEventListener('click', () => {
        const isOpen = trigger.classList.contains('is-active');
        
        trigger.classList.toggle('is-active');
        drawer.classList.toggle('is-active');
        trigger.setAttribute('aria-expanded', !isOpen);
        
        // Deshabilitar scroll del body para evitar fuga de scroll en móvil
        if (!isOpen) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_hero-section_dos"] && !Shopify.designMode) return;
  try {
    
  /* =============================================
     JS ENCAPSULADO CON ANIMACIÓN AVANZADA GSAP (OPT-IN)
     ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.gem-hero-section[data-section-id]');
    if (!section) return;

    const animEnabled = section.dataset.animate === 'true';
    if (!animEnabled) return;

    // Guard Clause defensivo: ¿Está GSAP cargado en theme.liquid?
    if (typeof gsap !== 'undefined') {
      const sectionId = section.dataset.sectionId;
      const textCol = section.querySelector('.gem-gsap-target-text');
      const mediaCol = section.querySelector('.gem-gsap-target-media');

      // Creamos un contexto gsap encapsulado para evitar fugas de memoria y selectors conflictivos
      const ctx = gsap.context(() => {
        const mm = gsap.matchMedia();

        mm.add({
          // Solo ejecuta las animaciones de movimiento si el usuario no prefiere reducir el movimiento (A11y)
          reduceMotion: "(prefers-reduced-motion: reduce)",
          animate: "(prefers-reduced-motion: no-preference)"
        }, (context) => {
          if (context.conditions.reduceMotion) return; // Retorno preventivo inmediato

          // Configuración básica de animación
          const animType = section.dataset.animationType;
          let entryVarsText = { opacity: 0 };
          let entryVarsMedia = { opacity: 0 };

          if (animType === 'fade-up') {
            entryVarsText.y = 40;
            entryVarsMedia.y = 30;
          } else if (animType === 'zoom-out') {
            entryVarsText.scale = 0.95;
            entryVarsMedia.scale = 1.05;
          }

          // Timeline de aparición acelerado para Above-the-fold
          const tl = gsap.timeline({
            defaults: {
              duration: 0.8,
              ease: "power3.out"
            }
          });

          if (textCol) {
            // Animamos de forma ordenada los hijos directos del bloque de texto
            const children = textCol.children;
            tl.from(children, {
              ...entryVarsText,
              stagger: 0.12,
              clearProps: "all"
            });
          }

          if (mediaCol) {
            tl.from(mediaCol, {
              ...entryVarsMedia,
              duration: 1.0,
              ease: "power2.out"
            }, "-=0.6");
          }

          // Activación complementaria del ScrollTrigger si se requiere parallax en la imagen lateral
          if (mediaCol && typeof ScrollTrigger !== 'undefined') {
            gsap.to(mediaCol, {
              scrollTrigger: {
                trigger: section,
                start: "top top",
                end: "bottom top",
                scrub: true
              },
              y: 50,
              ease: "none"
            });
          }
        });
      }, section);

      // Limpieza del contexto si Shopify Theme Editor vuelve a renderizar la sección
      section.addEventListener('shopify:section:unload', () => ctx.revert());

    } else {
      // FALLBACK SEGURO: Si GSAP no está disponible por problemas del CDN, aplicamos animación CSS suave de emergencia
      const textCol = section.querySelector('.gem-gsap-target-text');
      const mediaCol = section.querySelector('.gem-gsap-target-media');

      if (textCol) {
        textCol.style.opacity = '0';
        textCol.style.transform = 'translateY(20px)';
        textCol.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
        
        requestAnimationFrame(() => {
          textCol.style.opacity = '1';
          textCol.style.transform = 'translateY(0)';
        });
      }

      if (mediaCol) {
        mediaCol.style.opacity = '0';
        mediaCol.style.transform = 'scale(0.98)';
        mediaCol.style.transition = 'opacity 0.8s ease-out, transform 0.8s ease-out';
        mediaCol.style.transitionDelay = '0.2s';

        requestAnimationFrame(() => {
          mediaCol.style.opacity = '1';
          mediaCol.style.transform = 'scale(1)';
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_hero-section_tres"] && !Shopify.designMode) return;
  try {
    
  /* =============================================
     JS ENCAPSULADO CON DRIVER GSAP (WEB QUALITY A+)
     ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const heroModule = document.querySelector('.gem-hybrid-hero-wrapper[data-section-id]');
    if (!heroModule) return;

    const animationsEnabled = heroModule.dataset.animate === 'true';
    const shakeEnabled = heroModule.dataset.shake === 'true';

    if (typeof gsap === 'undefined') {
      console.warn('[GEM-GSAP] No se detectó GreenSock en el tema. Omitiendo secuencias animadas avanzadas.');
      return;
    }

    const ctx = gsap.context(() => {
      
      const mm = gsap.matchMedia();
      mm.add({
        reduceMotion: "(prefers-reduced-motion: reduce)",
        allowMotion: "(prefers-reduced-motion: no-preference)"
      }, (context) => {
        const { reduceMotion } = context.conditions;
        if (reduceMotion) return;

        const isMobile = window.innerWidth <= 991;

        // ACTIVACIÓN QUIRÚRGICA ATÓMICA: CADA ELEMENTO INICIALIZA SU PROPIO SCROLLTRIGGER INDEPENDIENTE
        if (animationsEnabled) {
          
          // 1. Imagen / Fondo Multimedia
          gsap.from('.gem-animate-media-pane', {
            scale: isMobile ? 1.05 : 1.02,
            duration: 1.4,
            ease: "power3.out",
            scrollTrigger: {
              trigger: '.gem-animate-media-pane',
              start: "top 95%",
              toggleActions: "play none none none"
            }
          });

          // 2. Tarjeta Neobrutalista de Texto (Dispara solo cuando entra en rango visual)
          const elementCard = heroModule.querySelector('.gem-animate-card-text');
          if (elementCard) {
            gsap.from(elementCard, {
              x: isMobile ? 0 : -35,
              y: isMobile ? 120 : 0,
              autoAlpha: 0,
              duration: isMobile ? 0.9 : 0.75,
              ease: "power3.out",
              scrollTrigger: {
                trigger: elementCard,
                start: "top 90%",
                toggleActions: "play none none none"
              }
            });
          }

          // 3. Grupo de Botones Accionables (Dispara de forma aislada al entrar en vista)
          const elementButtons = heroModule.querySelector('.gem-animate-buttons-group');
          if (elementButtons) {
            gsap.from(elementButtons, {
              x: isMobile ? 0 : -25,
              y: isMobile ? 80 : 0,
              autoAlpha: 0,
              duration: isMobile ? 0.7 : 0.6,
              ease: "power3.out",
              scrollTrigger: {
                trigger: elementButtons,
                start: "top 92%",
                toggleActions: "play none none none"
              }
            });
          }

          // 4. Bloque de Argumentos Comerciales / Badges Permanentes
          const elementBadges = heroModule.querySelector('.gem-animate-badges-container-entry');
          if (elementBadges) {
            gsap.from(elementBadges, {
              y: isMobile ? 60 : 20,
              autoAlpha: 0,
              duration: isMobile ? 0.6 : 0.5,
              ease: "power3.out",
              scrollTrigger: {
                trigger: elementBadges,
                start: "top 95%",
                toggleActions: "play none none none"
              }
            });
          }
        }

        // ANIMACIÓN CONTINUA AISLADA (SHAKE LOOP EN ELEMENTOS HIJOS)
        if (shakeEnabled) {
          gsap.to('.gem-sello-shake-trigger', {
            rotation: 1,
            yoyo: true,
            repeat: -1,
            duration: 2,
            stagger: 0.15,
            ease: "sine.inOut"
          });
        }

      });

    }, heroModule);

    heroModule.addEventListener('shopify:section:unload', () => {
      ctx.revert();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_lifestyle-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Encapsulado nativo listo para producción
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_lifestyle-section_dos"] && !Shopify.designMode) return;
  try {
    
  /* =============================================
     JS ENCAPSULADO CON REVELADOR DE SCROLL GSAP (OPT-IN)
     ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.gem-lifestyle-section');
    if (!section) return;

    const animEnabled = section.dataset.animate === 'true';
    if (!animEnabled) return;

    // Guard Clause defensivo: ¿Está GSAP & ScrollTrigger cargado en theme.liquid?
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      const bentoItems = section.querySelectorAll('.gem-gsap-bento-item');
      const testimonialCards = section.querySelectorAll('.gem-gsap-testimonial-card');

      const ctx = gsap.context(() => {
        const mm = gsap.matchMedia();

        mm.add({
          reduceMotion: "(prefers-reduced-motion: reduce)",
          animate: "(prefers-reduced-motion: no-preference)"
        }, (context) => {
          if (context.conditions.reduceMotion) return;

          // 1. ANIMACIÓN PARALLAX Y REVEAL EN EL BENTO GRID
          bentoItems.forEach((item, index) => {
            // Efecto de aparición elástica al entrar en pantalla
            gsap.from(item, {
              scrollTrigger: {
                trigger: item,
                start: "top 88%",
                toggleActions: "play none none none"
              },
              opacity: 0,
              y: 40,
              rotation: index % 2 === 0 ? -1.5 : 1.5, // Leve rotación gótica urbana
              duration: 0.8,
              ease: "back.out(1.25)",
              clearProps: "transform,opacity"
            });

            // Parallax sutil continuo de la imagen interna al hacer scroll
            const img = item.querySelector('img');
            if (img) {
              gsap.to(img, {
                scrollTrigger: {
                  trigger: item,
                  start: "top bottom",
                  end: "bottom top",
                  scrub: true
                },
                y: 15,
                ease: "none"
              });
            }
          });

          // 2. STAGGER EN LA APARECIZACIÓN DE TARJETAS DE TESTIMONIO
          gsap.from(testimonialCards, {
            scrollTrigger: {
              trigger: ".gem-testimonials-grid",
              start: "top 85%",
              toggleActions: "play none none none"
            },
            opacity: 0,
            y: 50,
            duration: 0.8,
            stagger: 0.12,
            ease: "power2.out",
            clearProps: "all"
          });

        });
      }, section);

      // Limpieza segura de los ScrollTriggers en el Editor de Temas de Shopify
      section.addEventListener('shopify:section:unload', () => ctx.revert());

    } else {
      // =============================================
      // FALLBACK NATIVO SIN DEPENDENCIAS (INTERSECTION OBSERVER)
      // =============================================
      const bentoItems = section.querySelectorAll('.gem-gsap-bento-item');
      const testimonialCards = section.querySelectorAll('.gem-gsap-testimonial-card');

      const fallbackObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            fallbackObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      bentoItems.forEach(item => {
        item.style.opacity = '0';
        item.style.transform = 'translateY(30px)';
        item.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
        fallbackObserver.observe(item);
      });

      testimonialCards.forEach((card, index) => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(30px)';
        card.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
        card.style.transitionDelay = (index * 0.1) + 's';
        fallbackObserver.observe(card);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_manifest-section_dos"] && !Shopify.designMode) return;
  try {
    
  /* =============================================
     GSAP KINETIC STORYTELLER v4.0 - Fix Definitivo
     Problema: GSAP está cargado pero la sección no lo detecta.
     Solución: Sistema de detección con retry + evento global.
     ============================================= */

  (function() {
    'use strict';

    // =============================================
    // SISTEMA DE DETECCIÓN ROBUSTA DE GSAP
    // =============================================
    var GSAP_CHECK_INTERVAL = 100; // ms
    var GSAP_MAX_RETRIES = 50;    // 5 segundos máximo
    var gsapRetryCount = 0;
    var gsapReadyCallbacks = [];
    var gsapIsReady = false;

    function onGSAPReady(callback) {
      if (gsapIsReady || (typeof gsap !== 'undefined' && typeof gsap.timeline === 'function')) {
        gsapIsReady = true;
        callback(true);
      } else {
        gsapReadyCallbacks.push(callback);
      }
    }

    function checkGSAP() {
      if (typeof gsap !== 'undefined' && typeof gsap.timeline === 'function') {
        gsapIsReady = true;
        gsapReadyCallbacks.forEach(function(cb) { cb(true); });
        gsapReadyCallbacks = [];
        return true;
      }
      return false;
    }

    // Polling inicial
    var gsapCheckTimer = setInterval(function() {
      gsapRetryCount++;
      if (checkGSAP() || gsapRetryCount >= GSAP_MAX_RETRIES) {
        clearInterval(gsapCheckTimer);
        if (!gsapIsReady) {
          // GSAP nunca cargó - notificar a callbacks con false
          gsapReadyCallbacks.forEach(function(cb) { cb(false); });
          gsapReadyCallbacks = [];
        }
      }
    }, GSAP_CHECK_INTERVAL);

    // Escuchar evento global de carga de GSAP (si otras secciones lo disparan)
    document.addEventListener('gsap:loaded', function() {
      checkGSAP();
    });

    // =============================================
    // INICIALIZACIÓN DE LA SECCIÓN
    // =============================================
    function initSectionManifest(wrapper) {
      if (wrapper.dataset.initialized === 'true') return;

      var scenes = wrapper.querySelectorAll('.shsk-kinetic-scene');
      var prevBtn = wrapper.querySelector('.shsk-btn-prev');
      var nextBtn = wrapper.querySelector('.shsk-btn-next');

      if (scenes.length === 0 || !prevBtn || !nextBtn) {
        console.warn('[ShotSkull Manifest] No se encontraron escenas o botones');
        return;
      }

      var isAutoplayEnabled = wrapper.dataset.autoplay === 'true';
      var sceneDurationSec = parseFloat(wrapper.dataset.speed) || 6;
      var sceneDurationMs = sceneDurationSec * 1000;

      var currentActiveIndex = 0;
      var isPlaying = false;
      var sceneTimer = null;
      var introTriggered = false;
      var isTransitioning = false;
      var hasGSAP = false;
      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Esperar a GSAP antes de continuar
      onGSAPReady(function(gsapAvailable) {
        hasGSAP = gsapAvailable && !prefersReducedMotion;

        if (hasGSAP) {
          console.log('[ShotSkull Manifest] GSAP detectado. Animaciones activadas.');
        } else {
          console.log('[ShotSkull Manifest] GSAP no disponible. Usando fallback CSS.');
        }

        startLogic();
      });

      function startLogic() {
        // --- Utilidades de Timer ---
        function clearSceneTimer() {
          if (!sceneTimer) return;
          if (hasGSAP && sceneTimer.kill) {
            sceneTimer.kill();
          } else if (typeof sceneTimer === 'number') {
            clearTimeout(sceneTimer);
          }
          sceneTimer = null;
        }

        function scheduleSceneTimer(callback, delayMs) {
          clearSceneTimer();
          if (hasGSAP) {
            sceneTimer = gsap.delayedCall(delayMs / 1000, callback);
          } else {
            sceneTimer = setTimeout(callback, delayMs);
          }
        }

        // --- Colores de fondo ---
        function applyColors(index) {
          var targetScene = scenes[index];
          if (!targetScene) return;
          var targetBg = targetScene.dataset.sceneBg || '#fdfbf7';
          wrapper.style.backgroundColor = targetBg;
        }

        // --- Inicialización visual ---
        function initActiveSceneCards() {
          applyColors(currentActiveIndex);
          var activeScene = wrapper.querySelector('.shsk-kinetic-scene.is-active');
          if (!activeScene) return;

          activeScene.style.display = 'flex';
          var cards = activeScene.querySelectorAll('.shsk-kinetic-card');
          cards.forEach(function(card) {
            var rot = parseFloat(card.dataset.rotate) || 0;
            card.style.opacity = '1';
            card.style.transform = 'rotate(' + rot + 'deg) translateX(0) scale(1)';
          });
          var connectors = activeScene.querySelectorAll('.shsk-tape-connector');
          connectors.forEach(function(conn) {
            conn.style.opacity = '1';
            conn.style.transform = 'scale(1)';
          });
        }

        // --- Revelar botones ---
        function revealNavigationButtons() {
          if (hasGSAP) {
            gsap.fromTo([prevBtn, nextBtn], 
              { scale: 0, opacity: 0 },
              { scale: 1, opacity: 1, duration: 0.6, ease: "back.out(1.5)", stagger: 0.1 }
            );
          } else {
            prevBtn.style.opacity = '1';
            prevBtn.style.transform = 'scale(1)';
            nextBtn.style.opacity = '1';
            nextBtn.style.transform = 'scale(1)';
          }
        }

        // =============================================
        // TRANSICIÓN CINEMATOGRÁFICA
        // =============================================
        function animateSceneTransition(currentIndex, nextIndex, onCompleteCallback) {
          if (isTransitioning) return;
          isTransitioning = true;

          var currentScene = scenes[currentIndex];
          var nextScene = scenes[nextIndex];
          var currentCards = currentScene.querySelectorAll('.shsk-kinetic-card');
          var currentTapes = currentScene.querySelectorAll('.shsk-tape-connector');
          var nextCards = nextScene.querySelectorAll('.shsk-kinetic-card');
          var nextTapes = nextScene.querySelectorAll('.shsk-tape-connector');

          applyColors(nextIndex);

          // Fallback sin GSAP
          if (!hasGSAP) {
            currentScene.classList.remove('is-active');
            currentScene.style.display = 'none';
            currentCards.forEach(function(c) { c.style.opacity = '0'; });
            currentTapes.forEach(function(t) { t.style.opacity = '0'; });

            nextScene.classList.add('is-active');
            nextScene.style.display = 'flex';
            nextCards.forEach(function(card) {
              var rot = parseFloat(card.dataset.rotate) || 0;
              card.style.opacity = '1';
              card.style.transform = 'rotate(' + rot + 'deg) translateX(0) scale(1)';
            });
            nextTapes.forEach(function(tape) {
              tape.style.opacity = '1';
              tape.style.transform = 'scale(1)';
            });
            isTransitioning = false;
            if (onCompleteCallback) onCompleteCallback();
            return;
          }

          // =============================================
          // GSAP TIMELINE: Secuencia cinematográfica
          // =============================================
          var tl = gsap.timeline({
            defaults: { ease: "power3.inOut" },
            onStart: function() {
              nextScene.style.display = 'flex';
              nextScene.classList.add('is-active');

              // Estado inicial: elementos entrantes fuera de pantalla
              gsap.set(nextCards, { 
                x: function(i) { return i % 2 === 0 ? "100vw" : "-100vw"; },
                y: 60,
                opacity: 0,
                scale: 0.8,
                rotation: function(i) { return i % 2 === 0 ? 12 : -12; }
              });
              gsap.set(nextTapes, { scale: 0, opacity: 0, y: 20 });
            },
            onComplete: function() {
              currentScene.classList.remove('is-active');
              currentScene.style.display = 'none';

              // Limpiar inline styles de la escena saliente
              gsap.set(currentCards, { clearProps: "transform,opacity,scale,rotation,x,y" });
              gsap.set(currentTapes, { clearProps: "transform,opacity,scale,rotation,x,y" });

              isTransitioning = false;
              if (onCompleteCallback) onCompleteCallback();
            }
          });

          // FASE 1: Salida
          if (currentCards.length > 0) {
            tl.to(currentCards, {
              x: function(i) { return i % 2 === 0 ? "-60vw" : "60vw"; },
              y: -40,
              rotation: function(i) { return i % 2 === 0 ? -15 : 15; },
              opacity: 0,
              scale: 0.85,
              duration: 0.6,
              stagger: 0.05,
              ease: "power2.in"
            }, 0);
          }

          if (currentTapes.length > 0) {
            tl.to(currentTapes, {
              scale: 0,
              opacity: 0,
              y: -10,
              duration: 0.25,
              ease: "power2.in"
            }, 0.1);
          }

          // FASE 2: Entrada
          tl.to(nextCards, {
            x: "0%",
            y: 0,
            rotation: function(i, target) { return parseFloat(target.dataset.rotate) || 0; },
            opacity: 1,
            scale: 1,
            duration: 0.9,
            stagger: 0.12,
            ease: "back.out(1.1)"
          }, 0.35);

          // FASE 3: Cintas
          if (nextTapes.length > 0) {
            tl.to(nextTapes, {
              scale: 1,
              opacity: 1,
              y: 0,
              duration: 0.35,
              stagger: 0.06,
              ease: "back.out(1.7)"
            }, 0.7);
          }
        }

        // --- Navegación ---
        function goToScene(nextIndex) {
          if (nextIndex === currentActiveIndex || isTransitioning) return;

          animateSceneTransition(currentActiveIndex, nextIndex, function() {
            currentActiveIndex = nextIndex;
            if (isPlaying) {
              startAutoplayCycle();
            }
          });
        }

        function startAutoplayCycle() {
          scheduleSceneTimer(function() {
            var nextIndex = (currentActiveIndex + 1) % scenes.length;
            goToScene(nextIndex);
          }, sceneDurationMs);
        }

        // --- Secuencia de introducción ---
        function triggerIntroSequence() {
          if (introTriggered) return;
          introTriggered = true;

          var isFirstSceneIntro = scenes[0].dataset.isIntro === 'true';

          if (isFirstSceneIntro) {
            scheduleSceneTimer(function() {
              if (currentActiveIndex === 0) {
                goToScene(1);
                revealNavigationButtons();
                if (isAutoplayEnabled) {
                  isPlaying = true;
                  startAutoplayCycle();
                }
              }
            }, 3500);
          } else {
            revealNavigationButtons();
            if (isAutoplayEnabled) {
              isPlaying = true;
              startAutoplayCycle();
            }
          }
        }

        // --- Inicialización ---
        initActiveSceneCards();

        var isFirstSceneIntro = scenes[0].dataset.isIntro === 'true';
        if (!isFirstSceneIntro) {
          if (hasGSAP) {
            gsap.set([prevBtn, nextBtn], { scale: 1, opacity: 1 });
          } else {
            prevBtn.style.opacity = '1';
            prevBtn.style.transform = 'scale(1)';
            nextBtn.style.opacity = '1';
            nextBtn.style.transform = 'scale(1)';
          }
        }

        // Intersection Observer
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting && !introTriggered) {
              triggerIntroSequence();
            }
          });
        }, { threshold: 0.05 });

        observer.observe(wrapper);

        // Eventos de botones
        prevBtn.addEventListener('click', function() {
          isPlaying = false;
          clearSceneTimer();
          var prevIndex = currentActiveIndex - 1;
          if (prevIndex < 0) prevIndex = scenes.length - 1;
          goToScene(prevIndex);
        });

        nextBtn.addEventListener('click', function() {
          isPlaying = false;
          clearSceneTimer();
          var nextIdx = (currentActiveIndex + 1) % scenes.length;
          goToScene(nextIdx);
        });

        // Cleanup
        var sectionContainer = wrapper.closest('[id^="shopify-section-"]');
        if (sectionContainer) {
          sectionContainer.addEventListener('shopify:section:unload', function() {
            clearSceneTimer();
            observer.disconnect();
          });
        }

        wrapper.dataset.initialized = 'true';
      }
    }

    // =============================================
    // INICIALIZACIÓN GLOBAL
    // =============================================
    function initAllSections() {
      var wrappers = document.querySelectorAll('.shsk-kinetic-wrapper[data-section-id]');
      wrappers.forEach(function(wrapper) {
        initSectionManifest(wrapper);
      });
    }

    if (document.readyState !== 'loading') {
      initAllSections();
    } else {
      document.addEventListener('DOMContentLoaded', initAllSections);
    }

    document.addEventListener('shopify:section:load', function(event) {
      var wrapper = event.target.querySelector('.shsk-kinetic-wrapper');
      if (wrapper) {
        initSectionManifest(wrapper);
      }
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_manifest-section_tres"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initManifestSection(wrapper) {
      if (wrapper.dataset.initialized) return;

      var sectionId = wrapper.dataset.sectionId;
      var gsapEnabled = wrapper.dataset.enableGsap === 'true';
      var parallaxEnabled = wrapper.dataset.enableParallax === 'true';

      var content = wrapper.querySelector('.shsk-manifest-content');
      var titleBox = wrapper.querySelector('.shsk-manifest-title-box');
      var bodyBox = wrapper.querySelector('.shsk-manifest-body-box');
      var imageFrame = wrapper.querySelector('.shsk-manifest-image-frame');
      var cta = wrapper.querySelector('.shsk-manifest-cta-wrapper');

      if (!content) return;

      if (reducedMotion) {
        [titleBox, bodyBox, imageFrame, cta].forEach(function(el) {
          if (el) {
            el.style.opacity = '1';
            el.style.transform = 'none';
          }
        });
        wrapper.dataset.initialized = 'true';
        return;
      }

      if (!gsapEnabled || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        initFallbackAnimation(wrapper, titleBox, bodyBox, imageFrame, cta);
        return;
      }

      try {
        gsap.registerPlugin(ScrollTrigger);

        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: wrapper,
            start: "top 80%",
            toggleActions: "play none none reverse",
            once: true
          }
        });

        tl.from(titleBox, {
          y: 50,
          opacity: 0,
          duration: 0.8,
          ease: "power3.out"
        })
        .from(bodyBox, {
          y: 40,
          opacity: 0,
          duration: 0.8,
          ease: "power3.out"
        }, "-=0.5")
        .from(imageFrame, {
          y: 60,
          opacity: 0,
          rotation: 0,
          duration: 1,
          ease: "back.out(1.2)"
        }, "-=0.6")
        .from(cta, {
          y: 30,
          opacity: 0,
          duration: 0.6,
          ease: "power2.out"
        }, "-=0.4");

        if (parallaxEnabled && imageFrame) {
          gsap.to(imageFrame, {
            y: -40,
            ease: "none",
            scrollTrigger: {
              trigger: wrapper,
              start: "top bottom",
              end: "bottom top",
              scrub: 1.5
            }
          });
        }

        var sectionContainer = wrapper.closest('[id^="shopify-section-"]');
        if (sectionContainer) {
          sectionContainer.addEventListener('shopify:section:unload', function() {
            tl.kill();
            if (parallaxEnabled && imageFrame) {
              var triggers = ScrollTrigger.getAll().filter(function(t) {
                return t.trigger === wrapper || t.trigger === imageFrame;
              });
              triggers.forEach(function(t) { t.kill(); });
            }
          });
        }

      } catch (e) {
        console.warn('GSAP error in manifest section, falling back:', e);
        initFallbackAnimation(wrapper, titleBox, bodyBox, imageFrame, cta);
      }

      wrapper.dataset.initialized = 'true';
    }

    function initFallbackAnimation(wrapper, titleBox, bodyBox, imageFrame, cta) {
      var elements = [titleBox, bodyBox, imageFrame, cta].filter(Boolean);

      elements.forEach(function(el, i) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity 0.8s ease-out ' + (i * 0.15) + 's, transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) ' + (i * 0.15) + 's';
      });

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            elements.forEach(function(el) {
              el.style.opacity = '1';
              el.style.transform = 'translateY(0)';
            });
            observer.disconnect();
          }
        });
      }, { threshold: 0.15 });

      observer.observe(wrapper);

      var sectionContainer = wrapper.closest('[id^="shopify-section-"]');
      if (sectionContainer) {
        sectionContainer.addEventListener('shopify:section:unload', function() {
          observer.disconnect();
        });
      }

      wrapper.dataset.initialized = 'true';
    }

    function initAll() {
      document.querySelectorAll('.shsk-manifest-hero').forEach(function(el) {
        initManifestSection(el);
      });
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function(event) {
      var wrapper = event.target.querySelector('.shsk-manifest-hero');
      if (wrapper) initManifestSection(wrapper);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_manifest-section_uno"] && !Shopify.designMode) return;
  try {
    
  /* =============================================
     JS ENCAPSULADO — GSAP & ScrollTrigger
     Cero interpolaciones Liquid. Todo data-driven.
  ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.gem-manifiesto-wrapper[data-section-id]');
    
    sections.forEach(section => {
      const sectionId = section.dataset.sectionId;
      const animateEnabled = section.dataset.animate === 'true';
      const staggerTime = parseFloat(section.dataset.stagger) || 0.2;
      const autoplayEnabled = section.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) * 1000 || 4000;
      
      const slider = section.querySelector('.gem-manifiesto-grid-slider');
      let autoplayTimer = null;

      // 1. ANIMACIONES DE REVELACIÓN (GSAP)
      if (animateEnabled && typeof gsap !== 'undefined') {
        const title = section.querySelector('.JS-reveal-title');
        const cards = section.querySelectorAll('.JS-reveal-card');

        // Context para aislamiento de animaciones en Shopify Theme Editor
        const ctx = gsap.context(() => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: section,
              start: 'top 80%', // Dispara cuando el 80% superior de la sección entra al viewport
              toggleActions: 'play none none none'
            }
          });

          // Animación Título Principal
          if (title) {
            tl.fromTo(title, {
              opacity: 0,
              y: 40
            }, {
              opacity: 1,
              y: 0,
              duration: 0.8,
              ease: 'power3.out'
            });
          }

          // Animación Tarjetas Staggered con rotación brutalista aleatoria leve
          if (cards.length > 0) {
            tl.fromTo(cards, {
              opacity: 0,
              y: 50,
              rotation: () => gsap.utils.random(-2, 2)
            }, {
              opacity: 1,
              y: 0,
              rotation: 0,
              duration: 0.8,
              stagger: staggerTime,
              ease: 'back.out(1.2)'
            }, '-=0.4'); // Solapamiento
          }
        }, section);

        // Limpieza si el Merchant desinstala o actualiza la sección
        section.addEventListener('shopify:section:unload', () => {
          ctx.revert();
          if (autoplayTimer) clearInterval(autoplayTimer);
        });
      }

      // 2. LÓGICA DE AUTOPLAY MÓVIL (Natas/CSS Snap + GSAP backup)
      if (slider && autoplayEnabled) {
        let isInteracted = false;
        const totalCards = slider.children.length;
        let currentIndex = 0;

        const startAutoplay = () => {
          autoplayTimer = setInterval(() => {
            if (isInteracted) return;

            currentIndex = (currentIndex + 1) % totalCards;
            const targetCard = slider.children[currentIndex];
            
            if (targetCard) {
              slider.scrollTo({
                left: targetCard.offsetLeft - slider.offsetLeft,
                behavior: 'smooth'
              });
            }
          }, autoplaySpeed);
        };

        // Detener autoplay si el usuario toca, arrastra o hace hover
        const stopAutoplayPermanently = () => {
          isInteracted = true;
          if (autoplayTimer) {
            clearInterval(autoplayTimer);
          }
        };

        slider.addEventListener('touchstart', stopAutoplayPermanently, { passive: true });
        slider.addEventListener('mousedown', stopAutoplayPermanently, { passive: true });
        slider.addEventListener('scroll', () => {
          // Detectar si fue scroll de usuario (no automatizado)
          if (slider.scrollLeft > 0 && !isInteracted && Math.random() < 0.05) {
            // El usuario hizo un gesto manual
            stopAutoplayPermanently();
          }
        }, { passive: true });

        // Inicializar
        startAutoplay();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_navigation-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.gem-header-wrapper');
    if (!header) return;

    // Lógica básica para ocultar/mostrar en scroll si fuera necesario
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 100 && currentScroll > lastScroll) {
        // header.style.transform = 'translateY(-100%)'; // Opcional: ocultar al bajar
      } else {
        header.style.transform = 'translateY(0)';
      }
      lastScroll = currentScroll;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_packs-section_tres"] && !Shopify.designMode) return;
  try {
    
  /* =============================================
     MOTOR DE INTERACCIÓN REACTIVO DE 3 FORMATOS (6, 9 y 12 PACKS)
  ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const builder = document.getElementById('PackBuilderSection');
    if (!builder) return;

    // Caché de elementos estáticos del DOM
    const dom = {
      cajaVisual: document.getElementById('CajaVisual'),
      mainForm: document.getElementById('PackBuilderForm'),
      mobileStickyBar: document.getElementById('MobileStickyBar'),
      buyBtnMobile: document.getElementById('StickyBuyBtn'),
      stickyDock: document.getElementById('StickyDock'),
      autofillBtn: document.getElementById('QuickAutofillBtn'),
      clearPackBtn: document.getElementById('ClearPackBtn'),
      errorModal: document.getElementById('GemErrorModal'),
      errorModalText: document.getElementById('GemErrorModalText'),
      errorModalDebug: document.getElementById('GemErrorModalDebugText'),
      errorModalClose: document.getElementById('GemErrorModalCloseBtn'),
      summaryText: document.getElementById('SummaryText'),
      summaryPrice: document.getElementById('SummaryPrice'),
      buyBtnText: document.getElementById('BuyBtnText'),
      summaryShippingInfo: document.getElementById('SummaryShippingInfo'),
      stickyCount: document.getElementById('StickyCount'),
      stickyPrice: document.getElementById('StickyPrice'),
      mainSubmitBtn: document.getElementById('MainSubmitBtn'),
      variantInput: document.getElementById('VariantInput'),
      stickyLiquid: document.getElementById('StickyLiquid'),
      desktopLiquidFill: document.getElementById('DesktopLiquidFill'),
      propertiesContainer: document.getElementById('DynamicPropertiesContainer')
    };

    const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const animEnabled = builder.querySelector('.gem-title-reveal') !== null;
    const sizers = builder.querySelectorAll('.gem-pack-sizer-option');
    const flavors = builder.querySelectorAll('.gem-flavor-row');

    const priceSix = parseInt(builder.dataset.priceSix, 10) || 84000;
    const priceNine = parseInt(builder.dataset.priceNine, 10) || 126000;
    const priceTwelve = parseInt(builder.dataset.priceTwelve, 10) || 168000;

    const mangoImg = builder.dataset.imgMango || 'https://cdn.shopify.com/s/files/1/0819/3313/0043/files/render_mango_450.png?v=1700000000';
    const pinaImg = builder.dataset.imgPina || 'https://cdn.shopify.com/s/files/1/0819/3313/0043/files/render_pina_450.png?v=1700000000';
    const moraImg = builder.dataset.imgMora || 'https://cdn.shopify.com/s/files/1/0819/3313/0043/files/render_mora_450.png?v=1700000000';

    const colors = {
      mango: '#4CAF50',
      pina: '#FFB800',
      mora: '#7A00FF'
    };

    const flavorNames = {
      mango: 'Mango Viche',
      pina: 'Piñacoco',
      mora: 'Morasul'
    };

    let currentPackSize = 6;
    let counts = { mango: 0, pina: 0, mora: 0 };
    let lastSelectedFlavor = 'mango';
    let wasComplete = false;
    let activeFlightsCount = 0;
    let isSectionInView = true;

    // Observador de visibilidad para ahorrar recursos
    if (typeof IntersectionObserver !== 'undefined') {
      const visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          isSectionInView = entry.isIntersecting;
          if (dom.mobileStickyBar) {
            if (entry.isIntersecting) {
              dom.mobileStickyBar.classList.add('is-visible');
            } else {
              dom.mobileStickyBar.classList.remove('is-visible');
            }
          }
        });
      }, { threshold: 0.05, rootMargin: "0px 0px -40px 0px" });

      const interactiveGrid = builder.querySelector('.gem-builder-grid');
      visibilityObserver.observe(interactiveGrid || builder);
    }

    // Burbujas ambientales optimizadas
    function startAmbientBubbles() {
      const liquidBody = document.querySelector('#StickyLiquid .gem-liquid-body');
      if (!liquidBody || isReducedMotion) return;
      
      setInterval(() => {
        if (!isSectionInView) return; 
        const total = Object.values(counts).reduce((a, b) => a + b, 0);
        if (total === 0) return;
        
        const bubble = document.createElement('div');
        bubble.className = 'gem-celebration-bubble';
        
        const size = Math.random() * 6 + 1.5; 
        bubble.style.width = `${size}px`;
        bubble.style.height = `${size}px`;
        bubble.style.left = `${Math.random() * 100}%`;
        bubble.style.bottom = '0';
        
        liquidBody.appendChild(bubble);
        
        if (typeof gsap !== 'undefined') {
          gsap.fromTo(bubble, 
            { y: 60, opacity: 0.7, scale: 0.8 }, 
            { 
              y: -140, 
              x: '+=random(-16, 16)', 
              opacity: 0, 
              duration: Math.random() * 2.0 + 0.8, 
              ease: "power1.out",
              onComplete: () => bubble.remove() 
            }
          );
        } else {
          bubble.classList.add('is-native-anim');
          setTimeout(() => bubble.remove(), 1200);
        }
      }, 220);
    }

    // Ráfaga de burbujas (Fizz Burst)
    function triggerFizzBurst() {
      const liquidBody = document.querySelector('#StickyLiquid .gem-liquid-body');
      if (!liquidBody || isReducedMotion) return;
      const total = Object.values(counts).reduce((a, b) => a + b, 0);
      if (total === 0) return;

      const totalBubbles = 12;

      for (let i = 0; i < totalBubbles; i++) {
        const bubble = document.createElement('div');
        bubble.className = 'gem-celebration-bubble';
        const size = Math.random() * 8 + 3;
        bubble.style.width = `${size}px`;
        bubble.style.height = `${size}px`;
        bubble.style.left = `${Math.random() * 100}%`;
        bubble.style.bottom = '0';
        liquidBody.appendChild(bubble);

        if (typeof gsap !== 'undefined') {
          gsap.fromTo(bubble, 
            { y: 60, opacity: 0.95, scale: 0.5 }, 
            { 
              y: -150, 
              x: '+=random(-25, 25)', 
              opacity: 0, 
              scale: Math.random() * 1.5 + 0.8,
              duration: Math.random() * 0.7 + 0.4,
              ease: "power2.out",
              onComplete: () => bubble.remove() 
            }
          );
        } else {
          bubble.classList.add('is-native-anim');
          setTimeout(() => bubble.remove(), 1200);
        }
      }
    }

    // Animaciones de entrada iniciales
    if (animEnabled && !isReducedMotion) {
      if (typeof gsap !== 'undefined') {
        const revealTl = gsap.timeline();
        revealTl.fromTo('.gem-title-reveal', { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.6, ease: "power2.out" })
                .fromTo('.gem-desc-reveal', { opacity: 0, y: -10 }, { opacity: 1, y: 0, duration: 0.5, ease: "power2.out" }, "-=0.3")
                .fromTo('.gem-pack-sizer-option', { opacity: 0, scale: 0.95 }, { opacity: 1, scale: 1, duration: 0.4, stagger: 0.12, ease: "back.out(1.2)" }, "-=0.2")
                .fromTo('.gem-flavor-row', { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.6, stagger: 0.12, ease: "power2.out" }, "-=0.1");
      } else {
        document.querySelectorAll('.gem-title-reveal, .gem-desc-reveal, .gem-pack-sizer-option, .gem-flavor-row').forEach(el => {
          el.style.opacity = '1';
          el.style.transform = 'none';
        });
      }
    }

    // Selección de Tamaño de Pack (6, 9 o 12 botellas)
    sizers.forEach(sizer => {
      function selectSizerOption() {
        if (sizer.classList.contains('is-active')) return;

        const targetSize = parseInt(sizer.dataset.size, 10) || 6;

        sizers.forEach(s => {
          s.classList.remove('is-active');
          s.setAttribute('aria-checked', 'false');
        });
        sizer.classList.add('is-active');
        sizer.setAttribute('aria-checked', 'true');

        if (dom.variantInput) {
          dom.variantInput.value = sizer.dataset.variantId;
        }

        if (window.innerWidth > 991 && dom.cajaVisual && !isReducedMotion) {
          if (typeof gsap !== 'undefined') {
            gsap.to(dom.cajaVisual, {
              opacity: 0,
              scale: 0.96,
              duration: 0.14,
              ease: "power2.in",
              onComplete: () => {
                currentPackSize = targetSize;
                counts = { mango: 0, pina: 0, mora: 0 };
                initMobileStickyDock();
                updateInterface();

                gsap.fromTo(dom.cajaVisual, 
                  { opacity: 0, scale: 0.96 },
                  { opacity: 1, scale: 1, duration: 0.35, ease: "back.out(1.15)", clearProps: "transform" }
                );
              }
            });
          } else {
            dom.cajaVisual.style.opacity = '0.3';
            setTimeout(() => {
              currentPackSize = targetSize;
              counts = { mango: 0, pina: 0, mora: 0 };
              initMobileStickyDock();
              updateInterface();
              dom.cajaVisual.style.opacity = '1';
            }, 150);
          }
        } else {
          currentPackSize = targetSize;
          counts = { mango: 0, pina: 0, mora: 0 };
          initMobileStickyDock();
          updateInterface();
        }
      }

      sizer.addEventListener('click', selectSizerOption);
      sizer.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectSizerOption();
        }
      });
    });

    // Llenar con Mezcla Surtida Equitativa
    if (dom.autofillBtn) {
      dom.autofillBtn.addEventListener('click', () => {
        if (currentPackSize === 6) {
          counts = { mango: 2, pina: 2, mora: 2 };
        } else if (currentPackSize === 9) {
          counts = { mango: 3, pina: 3, mora: 3 };
        } else if (currentPackSize === 12) {
          counts = { mango: 4, pina: 4, mora: 4 };
        }
        lastSelectedFlavor = 'mango';
        updateInterface();
        
        if (typeof gsap !== 'undefined' && !isReducedMotion) {
          gsap.fromTo(dom.autofillBtn, 
            { scale: 0.95 },
            { scale: 1, duration: 0.3, ease: "back.out(1.5)" }
          );
        }
      });
    }

    // Vaciar Pack
    if (dom.clearPackBtn) {
      dom.clearPackBtn.addEventListener('click', () => {
        const total = Object.values(counts).reduce((a, b) => a + b, 0);
        if (total === 0) return;

        if (typeof gsap !== 'undefined' && !isReducedMotion) {
          const filledSlots = document.querySelectorAll('#CajaVisual .gem-box-slot:not(.is-empty), #StickyDock .gem-sticky-slot:not(.is-empty)');
          gsap.to(filledSlots, {
            scale: 0.5,
            opacity: 0,
            duration: 0.2,
            stagger: 0.03,
            ease: "power2.in",
            onComplete: () => {
              gsap.set(filledSlots, { clearProps: "all" });
              counts = { mango: 0, pina: 0, mora: 0 };
              updateInterface();
            }
          });
        } else {
          counts = { mango: 0, pina: 0, mora: 0 };
          updateInterface();
        }
      });
    }

    // Contadores de sabor
    flavors.forEach(row => {
      const key = row.dataset.flavor;
      const plusBtn = row.querySelector('.gem-counter-btn.plus');
      const minusBtn = row.querySelector('.gem-counter-btn.minus');

      plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const total = Object.values(counts).reduce((a, b) => a + b, 0);
        if (total < currentPackSize) {
          counts[key]++;
          lastSelectedFlavor = key;

          if (window.innerWidth <= 991) {
            activeFlightsCount++;
            triggerMobileFlight(plusBtn, key, total);
            requestAnimationFrame(() => triggerFizzBurst());
          }

          requestAnimationFrame(() => updateInterface());

          if (window.innerWidth > 991 && animEnabled && typeof gsap !== 'undefined' && !isReducedMotion && dom.cajaVisual) {
            gsap.fromTo(dom.cajaVisual, 
              { x: -5 },
              { x: 0, duration: 0.3, ease: "rough", clearProps: "x" }
            );
          }
        }
      });

      minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (counts[key] > 0) {
          counts[key]--;
          updateInterface();
        }
      });
    });

    // Remoción de botellas interactiva en Desktop Slots
    function handleSlotInteraction(slot) {
      if (!slot || slot.classList.contains('is-empty')) return;
      let flavorKey = null;
      if (slot.classList.contains('is-mango')) flavorKey = 'mango';
      else if (slot.classList.contains('is-pina')) flavorKey = 'pina';
      else if (slot.classList.contains('is-mora')) flavorKey = 'mora';

      if (flavorKey && counts[flavorKey] > 0) {
        counts[flavorKey]--;
        
        if (typeof gsap !== 'undefined' && !isReducedMotion) {
          gsap.to(slot, {
            scale: 0.7,
            opacity: 0,
            duration: 0.2,
            ease: "power2.out",
            onComplete: () => {
              gsap.set(slot, { clearProps: "all" });
              updateInterface();
            }
          });
        } else {
          updateInterface();
        }
      }
    }

    if (dom.cajaVisual) {
      dom.cajaVisual.addEventListener('click', (e) => {
        const slot = e.target.closest('.gem-box-slot');
        handleSlotInteraction(slot);
      });
      dom.cajaVisual.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          const slot = e.target.closest('.gem-box-slot');
          if (slot) {
            e.preventDefault();
            handleSlotInteraction(slot);
          }
        }
      });
    }

    // Remoción de botellas interactiva en Mobile Sticky Dock
    if (dom.stickyDock) {
      dom.stickyDock.addEventListener('click', (e) => {
        const slot = e.target.closest('.gem-sticky-slot');
        handleSlotInteraction(slot);
      });
      dom.stickyDock.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          const slot = e.target.closest('.gem-sticky-slot');
          if (slot) {
            e.preventDefault();
            handleSlotInteraction(slot);
          }
        }
      });
    }

    // Animación de Vuelo Móvil con Fallback CSS Nativo
    function triggerMobileFlight(button, flavorKey, targetSlotIndex) {
      if (isReducedMotion) {
        activeFlightsCount--;
        return;
      }

      const rectBtn = button.getBoundingClientRect();
      const startX = rectBtn.left + rectBtn.width / 2;
      const startY = rectBtn.top + rectBtn.height / 2;

      const slots = document.querySelectorAll('#StickyDock .gem-sticky-slot');
      if (!slots || slots.length <= targetSlotIndex) {
        activeFlightsCount--;
        return;
      }
      const targetSlot = slots[targetSlotIndex];
      const rectSlot = targetSlot.getBoundingClientRect();
      const endX = rectSlot.left + rectSlot.width / 2;
      const endY = rectSlot.top + rectSlot.height / 2;

      const flyEl = document.createElement('div');
      flyEl.className = `gem-fly-item is-${flavorKey}`;
      
      const dockStyle = dom.mobileStickyBar ? (dom.mobileStickyBar.dataset.dockStyle || 'caps') : 'caps';
      const accentColor = colors[flavorKey];

      if (dockStyle === 'caps') {
        flyEl.innerHTML = `
          <div class="gem-fly-cap" style="background-color: ${accentColor};">
            <svg viewBox="0 0 24 24" class="gem-skull-svg" aria-hidden="true">
              <path fill="#FFFFFF" d="M12,2C7.58,2,4,5.58,4,10c0,2.15,0.85,4.1,2.23,5.54L6,21c0,0.55,0.45,1,1,1h10c0.55,0,1-0.45,1-1l-0.23-5.46 C19.15,14.1,20,12.15,20,10C20,5.58,16.42,2,12,2z M9,11c-0.83,0-1.5-0.67-1.5-1.5S8.17,8,9,8s1.5,0.67,1.5,1.5S9.83,11,9,11z M15,11 c-0.83,0-1.5-0.67-1.5-1.5S14.17,8,15,8s1.5,0.67,1.5,1.5S15.83,11,15,11z M12,18h-2v-2h2V18z M12,15H9v-2h3V15z M15,15h-2v-2h2V15z"/>
            </svg>
          </div>
        `;
      } else {
        let imgUrl = mangoImg;
        if (flavorKey === 'pina') imgUrl = pinaImg;
        if (flavorKey === 'mora') imgUrl = moraImg;
        flyEl.innerHTML = `<img src="${imgUrl}" class="gem-fly-bottle" style="height: 44px; width: auto; object-fit: contain;" alt="Fly" />`;
      }

      document.body.appendChild(flyEl);

      if (typeof gsap !== 'undefined') {
        gsap.set(flyEl, {
          x: startX,
          y: startY,
          xPercent: -50,
          yPercent: -50,
          scale: 1.3,
          opacity: 1,
          force3D: true
        });

        const midY = Math.min(startY, endY) - 90;

        const timeline = gsap.timeline({
          onComplete: () => {
            flyEl.remove();
            activeFlightsCount--;

            gsap.fromTo(targetSlot, 
              { scale: 0.8 }, 
              { scale: 1, duration: 0.45, ease: "elastic.out(1.2, 0.5)", clearProps: "opacity,transform" }
            );
            
            triggerColdMist(endX, endY);

            const total = Object.values(counts).reduce((a, b) => a + b, 0);
            if (activeFlightsCount === 0 && total === currentPackSize) {
              triggerPackCompleteCelebration();
            }
          }
        });

        timeline.to(flyEl, { x: endX, duration: 0.65, ease: "power1.out" }, 0)
                .to(flyEl, { y: midY, duration: 0.28, ease: "power1.out" }, 0)
                .to(flyEl, { y: endY, duration: 0.37, ease: "power2.in" }, 0.28)
                .to(flyEl, { scale: 0.75, rotation: 'random(-120, 120)', duration: 0.65, ease: "power1.out" }, 0);
      } else {
        flyEl.classList.add('is-native-anim');
        flyEl.style.setProperty('--fly-start-x', `${startX}px`);
        flyEl.style.setProperty('--fly-start-y', `${startY}px`);
        flyEl.style.setProperty('--fly-end-x', `${endX}px`);
        flyEl.style.setProperty('--fly-end-y', `${endY}px`);

        setTimeout(() => {
          flyEl.remove();
          activeFlightsCount--;
          triggerColdMist(endX, endY);
          const total = Object.values(counts).reduce((a, b) => a + b, 0);
          if (activeFlightsCount === 0 && total === currentPackSize) {
            triggerPackCompleteCelebration();
          }
        }, 550);
      }
    }

    // Efecto de Niebla Fría
    function triggerColdMist(x, y) {
      if (isReducedMotion) return;

      const mistCount = 3;
      for (let i = 0; i < mistCount; i++) {
        const mist = document.createElement('div');
        mist.className = 'gem-cold-mist';
        const size = Math.random() * 16 + 16; 
        mist.style.width = `${size}px`;
        mist.style.height = `${size}px`;

        if (typeof gsap !== 'undefined') {
          document.body.appendChild(mist);
          gsap.set(mist, {
            x: x,
            y: y,
            xPercent: -50,
            yPercent: -50,
            opacity: 0.65,
            scale: 0.4
          });

          const angle = (Math.random() * Math.PI) + Math.PI; 
          const dist = Math.random() * 40 + 12;
          const destX = x + Math.cos(angle) * dist;
          const destY = y + Math.sin(angle) * dist - Math.random() * 15;

          gsap.to(mist, {
            x: destX,
            y: destY,
            scale: Math.random() * 1.5 + 1.1,
            opacity: 0,
            duration: Math.random() * 0.4 + 0.5,
            ease: "power2.out",
            onComplete: () => mist.remove()
          });
        } else {
          mist.classList.add('is-native-anim');
          mist.style.left = `${x}px`;
          mist.style.top = `${y}px`;
          document.body.appendChild(mist);
          setTimeout(() => mist.remove(), 500);
        }
      }
    }

    // Celebración al completar el pack
    function triggerPackCompleteCelebration() {
      if (isReducedMotion) return;

      if (typeof gsap !== 'undefined') {
        const celTl = gsap.timeline();

        const mobileSlots = document.querySelectorAll('#StickyDock .gem-sticky-slot');
        if (mobileSlots.length > 0) {
          celTl.fromTo(mobileSlots, 
            { y: 0 }, 
            { y: -12, duration: 0.2, yoyo: true, repeat: 1, stagger: 0.03, ease: "power2.out", clearProps: "y" },
            0.05
          );
        }

        const desktopSlots = document.querySelectorAll('#CajaVisual .gem-box-slot');
        if (desktopSlots.length > 0) {
          celTl.fromTo(desktopSlots, 
            { y: 0 }, 
            { y: -10, duration: 0.2, yoyo: true, repeat: 1, stagger: 0.03, ease: "power2.out", clearProps: "y" },
            0.05
          );
        }

        if (dom.buyBtnMobile) {
          celTl.add(() => dom.buyBtnMobile.classList.add('is-pulsing'), 0.15);
          celTl.fromTo(dom.buyBtnMobile, 
            { scale: 1 }, 
            { scale: 1.08, duration: 0.25, yoyo: true, repeat: 1, ease: "back.out(1.4)" },
            0.15
          );
        }

        if (dom.mainSubmitBtn) {
          celTl.fromTo(dom.mainSubmitBtn, 
            { scale: 1 }, 
            { scale: 1.05, duration: 0.25, yoyo: true, repeat: 1, ease: "back.out(1.4)" },
            0.15
          );
        }

        celTl.add(() => triggerCelebrationBubbles(), 0.3);
      } else {
        if (dom.buyBtnMobile) dom.buyBtnMobile.classList.add('is-pulsing');
        triggerCelebrationBubbles();
      }
    }

    function triggerCelebrationBubbles() {
      const liquidBody = document.querySelector('#StickyLiquid .gem-liquid-body');
      if (!liquidBody || isReducedMotion) return;
      
      for (let i = 0; i < 16; i++) {
        const bubble = document.createElement('div');
        bubble.className = 'gem-celebration-bubble';
        const size = Math.random() * 9 + 4;
        bubble.style.width = `${size}px`;
        bubble.style.height = `${size}px`;
        bubble.style.left = `${Math.random() * 100}%`;
        liquidBody.appendChild(bubble);

        if (typeof gsap !== 'undefined') {
          gsap.fromTo(bubble, 
            { y: 60, opacity: 0.9 }, 
            { 
              y: -140, 
              x: '+=random(-18, 18)', 
              opacity: 0, 
              duration: Math.random() * 1.2 + 0.6, 
              ease: "power1.out",
              onComplete: () => bubble.remove() 
            }
          );
        } else {
          bubble.classList.add('is-native-anim');
          setTimeout(() => bubble.remove(), 1200);
        }
      }
    }

    function initMobileStickyDock() {
      if (!dom.stickyDock) return;

      dom.stickyDock.innerHTML = '';
      dom.stickyDock.classList.remove('is-9-pack', 'is-12-pack');

      if (currentPackSize === 9) {
        dom.stickyDock.classList.add('is-9-pack');
      } else if (currentPackSize === 12) {
        dom.stickyDock.classList.add('is-12-pack');
      }

      for (let i = 0; i < currentPackSize; i++) {
        const slotDiv = document.createElement('div');
        slotDiv.className = 'gem-sticky-slot is-empty';
        slotDiv.dataset.index = i;
        slotDiv.setAttribute('role', 'button');
        slotDiv.setAttribute('tabindex', '0');
        slotDiv.setAttribute('aria-label', `Ranura ${i + 1} de ${currentPackSize} en barra móvil: Vacía`);
        slotDiv.innerHTML = `<span class="gem-empty-cross">+</span>`;
        dom.stickyDock.appendChild(slotDiv);
      }
    }

    function renderMobileStickyDock() {
      if (!dom.stickyDock) return;

      const slots = dom.stickyDock.querySelectorAll('.gem-sticky-slot');
      
      if (slots.length !== currentPackSize) {
        initMobileStickyDock();
        return renderMobileStickyDock();
      }

      const packedFlavors = [];
      Object.entries(counts).forEach(([flavor, count]) => {
        for (let i = 0; i < count; i++) {
          packedFlavors.push(flavor);
        }
      });

      const filledCount = packedFlavors.length;
      const dockStyle = dom.mobileStickyBar ? (dom.mobileStickyBar.dataset.dockStyle || 'caps') : 'caps';

      slots.forEach((slotDiv, i) => {
        const slotNum = i + 1;

        if (typeof gsap !== 'undefined') {
          gsap.set(slotDiv, { clearProps: "opacity,transform" });
        } else {
          slotDiv.style.opacity = '';
          slotDiv.style.transform = '';
        }

        if (i < filledCount) {
          const flavor = packedFlavors[i];
          const accentColor = colors[flavor];
          const nombreSabor = flavorNames[flavor] || flavor;
          
          slotDiv.setAttribute('aria-label', `Ranura ${slotNum} de ${currentPackSize} en barra móvil: ${nombreSabor}. Haz clic o presiona Enter para remover`);

          if (!slotDiv.classList.contains(`is-${flavor}`)) {
            slotDiv.className = `gem-sticky-slot is-${flavor}`;
            slotDiv.style.setProperty('--slot-accent-color', accentColor);

            if (dockStyle === 'caps') {
              slotDiv.innerHTML = `
                <div class="gem-slot-cap" style="background-color: ${accentColor};">
                  <svg viewBox="0 0 24 24" class="gem-skull-svg" aria-hidden="true">
                    <path fill="#FFFFFF" d="M12,2C7.58,2,4,5.58,4,10c0,2.15,0.85,4.1,2.23,5.54L6,21c0,0.55,0.45,1,1,1h10c0.55,0,1-0.45,1-1l-0.23-5.46 C19.15,14.1,20,12.15,20,10C20,5.58,16.42,2,12,2z M9,11c-0.83,0-1.5-0.67-1.5-1.5S8.17,8,9,8s1.5,0.67,1.5,1.5S9.83,11,9,11z M15,11 c-0.83,0-1.5-0.67-1.5-1.5S14.17,8,15,8s1.5,0.67,1.5,1.5S15.83,11,15,11z M12,18h-2v-2h2V18z M12,15H9v-2h3V15z M15,15h-2v-2h2V15z"/>
                  </svg>
                </div>
              `;
            } else {
              let imgUrl = mangoImg;
              if (flavor === 'pina') imgUrl = pinaImg;
              if (flavor === 'mora') imgUrl = moraImg;
              slotDiv.innerHTML = `<img src="${imgUrl}" class="gem-slot-bottle" alt="Botella ${nombreSabor}" />`;
            }
          }
        } else {
          slotDiv.setAttribute('aria-label', `Ranura ${slotNum} de ${currentPackSize} en barra móvil: Vacía`);
          if (!slotDiv.classList.contains('is-empty')) {
            slotDiv.className = 'gem-sticky-slot is-empty';
            slotDiv.style.removeProperty('--slot-accent-color');
            slotDiv.innerHTML = `<span class="gem-empty-cross">+</span>`;
          }
        }
      });
    }

    function updateInterface() {
      const total = Object.values(counts).reduce((a, b) => a + b, 0);

      Object.keys(counts).forEach(key => {
        const plusBtn = document.querySelector(`.gem-counter-btn.plus[data-flavor="${key}"]`);
        const minusBtn = document.querySelector(`.gem-counter-btn.minus[data-flavor="${key}"]`);
        
        if (plusBtn) {
          if (total >= currentPackSize) {
            plusBtn.classList.add('disabled');
            plusBtn.setAttribute('aria-disabled', 'true');
          } else {
            plusBtn.classList.remove('disabled');
            plusBtn.setAttribute('aria-disabled', 'false');
          }
        }
        if (minusBtn) {
          if (counts[key] > 0) {
            minusBtn.classList.remove('disabled');
            minusBtn.setAttribute('aria-disabled', 'false');
          } else {
            minusBtn.classList.add('disabled');
            minusBtn.setAttribute('aria-disabled', 'true');
          }
        }
      });

      Object.entries(counts).forEach(([key, val]) => {
        const display = document.getElementById(`Count-${key}`);
        if (display) display.textContent = val;
      });

      // Propiedades de línea para Shopify
      if (dom.propertiesContainer) {
        dom.propertiesContainer.innerHTML = '';
        
        const currentSelectionList = [];
        Object.entries(counts).forEach(([flavorKey, flavorCount]) => {
          const flavorRow = builder.querySelector(`.gem-flavor-row[data-flavor="${flavorKey}"]`);
          const spanEl = flavorRow ? flavorRow.querySelector('.gem-flavor-details h4 span') : null;
          const flavorTitle = spanEl ? spanEl.textContent.trim() : flavorKey.toUpperCase();
          for (let i = 0; i < flavorCount; i++) {
            currentSelectionList.push(flavorTitle);
          }
        });

        currentSelectionList.forEach((saborNombre, index) => {
          const inputIdx = index + 1;
          const propInput = document.createElement('input');
          propInput.type = 'hidden';
          propInput.name = `properties[Sabor ${inputIdx}]`;
          propInput.value = saborNombre;
          dom.propertiesContainer.appendChild(propInput);
        });
      }

      let priceUnit = priceSix;
      if (currentPackSize === 9) priceUnit = priceNine;
      if (currentPackSize === 12) priceUnit = priceTwelve;

      const formattedPrice = new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(priceUnit);

      if (dom.summaryText) dom.summaryText.textContent = `${total} de ${currentPackSize} botellas agregadas`;
      if (dom.summaryPrice) dom.summaryPrice.textContent = formattedPrice;
      if (dom.buyBtnText) {
        dom.buyBtnText.textContent = total < currentPackSize ? `COMPLETA TU PACK (${total}/${currentPackSize})` : '¡PIDE TU PACK YA!';
      }

      if (dom.summaryShippingInfo) {
        if (currentPackSize === 12) {
          dom.summaryShippingInfo.innerHTML = `<span style="color: #4CAF50; font-weight: 900;">🎉 ¡ENVÍO GRATIS A TODA COLOMBIA!</span>`;
        } else {
          dom.summaryShippingInfo.innerHTML = `<span>🚚 Envío Bogotá $10.000 — ¡Gratis en 12-Pack!</span>`;
        }
      }

      if (dom.stickyCount) dom.stickyCount.textContent = `${total} de ${currentPackSize} bot.`;
      if (dom.stickyPrice) dom.stickyPrice.textContent = formattedPrice;

      if (dom.mainSubmitBtn) {
        if (total === currentPackSize) {
          dom.mainSubmitBtn.removeAttribute('disabled');
          dom.mainSubmitBtn.setAttribute('aria-disabled', 'false');
        } else {
          dom.mainSubmitBtn.setAttribute('disabled', 'disabled');
          dom.mainSubmitBtn.setAttribute('aria-disabled', 'true');
        }
      }

      if (dom.buyBtnMobile) {
        if (total === currentPackSize) {
          dom.buyBtnMobile.classList.remove('disabled');
          dom.buyBtnMobile.setAttribute('aria-disabled', 'false');
          dom.buyBtnMobile.querySelector('span').textContent = '¡PIDE YA TU PACK!';
        } else {
          dom.buyBtnMobile.classList.add('disabled');
          dom.buyBtnMobile.setAttribute('aria-disabled', 'true');
          dom.buyBtnMobile.querySelector('span').textContent = `AGREGA ${currentPackSize - total} BOT.`;
        }
      }

      if (lastSelectedFlavor && dom.mobileStickyBar) {
        const nextColor = colors[lastSelectedFlavor];
        dom.mobileStickyBar.style.setProperty('--liquid-color', nextColor);
      }

      const progressPercent = (total / currentPackSize) * 100;
      if (dom.stickyLiquid) {
        if (total === currentPackSize) {
          dom.stickyLiquid.style.transform = 'translateY(0%) scaleY(1.05)';
        } else {
          dom.stickyLiquid.style.transform = `translateY(${100 - progressPercent}%)`;
        }
      }

      // Sincronización del Medidor de Progreso Líquido Desktop
      if (dom.desktopLiquidFill) {
        dom.desktopLiquidFill.style.width = `${progressPercent}%`;
        if (lastSelectedFlavor) {
          dom.desktopLiquidFill.style.setProperty('--liquid-color', colors[lastSelectedFlavor]);
        }
      }

      renderMobileStickyDock();

      const isNowComplete = (total === currentPackSize);
      if (isNowComplete && !wasComplete) {
        wasComplete = true;
        if (window.innerWidth <= 991) {
          if (activeFlightsCount === 0) {
            triggerPackCompleteCelebration();
          }
        } else {
          triggerPackCompleteCelebration();
        }
      } else if (!isNowComplete) {
        wasComplete = false;
        if (dom.buyBtnMobile) dom.buyBtnMobile.classList.remove('is-pulsing');
      }

      // Sincronización Desktop & ARIA
      if (window.innerWidth > 991) {
        const packedFlavors = [];
        Object.entries(counts).forEach(([k, v]) => {
          for (let i = 0; i < v; i++) packedFlavors.push(k);
        });

        if (dom.cajaVisual) {
          dom.cajaVisual.classList.remove('is-9-pack', 'is-12-pack');
          if (currentPackSize === 9) {
            dom.cajaVisual.classList.add('is-9-pack');
          } else if (currentPackSize === 12) {
            dom.cajaVisual.classList.add('is-12-pack');
          }
        }

        for (let i = 1; i <= 12; i++) {
          const slot = document.getElementById(`BoxSlot-${i}`);
          if (slot) {
            if (typeof gsap !== 'undefined') {
              gsap.set(slot, { clearProps: "opacity,transform" });
            } else {
              slot.style.opacity = '';
              slot.style.transform = '';
            }

            slot.innerHTML = '';
            slot.className = 'gem-box-slot is-empty';
            slot.style.display = i > currentPackSize ? 'none' : 'flex';
            slot.setAttribute('aria-label', `Ranura ${i} de ${currentPackSize}: Vacía. Haz clic para llenar`);
          }
        }

        packedFlavors.forEach((flavor, idx) => {
          const slotIdx = idx + 1;
          const slot = document.getElementById(`BoxSlot-${slotIdx}`);
          if (slot) {
            const nombreSabor = flavorNames[flavor] || flavor;
            slot.classList.remove('is-empty');
            slot.classList.add(`is-${flavor}`);
            slot.setAttribute('aria-label', `Ranura ${slotIdx} de ${currentPackSize}: ${nombreSabor}. Haz clic o presiona Enter para remover`);
            
            let imgUrl = mangoImg;
            if (flavor === 'pina') imgUrl = pinaImg;
            if (flavor === 'mora') imgUrl = moraImg;

            slot.innerHTML = `
              <div class="gem-slotted-bottle">
                <img src="${imgUrl}" alt="Botella de ${nombreSabor}" loading="lazy" decoding="async" width="100" height="200">
              </div>
            `;
          }
        });
      }
    }

    function showErrorModal(message, debugInfo) {
      if (dom.errorModal && dom.errorModalText && dom.errorModalDebug) {
        dom.errorModalText.textContent = message;
        dom.errorModalDebug.textContent = debugInfo;
        dom.errorModal.style.display = 'flex';
        
        if (typeof gsap !== 'undefined' && !isReducedMotion) {
          gsap.fromTo(dom.errorModal.querySelector('.gem-error-modal-card'),
            { scale: 0.8, opacity: 0 },
            { scale: 1, opacity: 1, duration: 0.3, ease: "back.out(1.2)" }
          );
        }
      }
    }

    if (dom.errorModalClose) {
      dom.errorModalClose.addEventListener('click', () => {
        if (dom.errorModal) {
          if (typeof gsap !== 'undefined' && !isReducedMotion) {
            gsap.to(dom.errorModal.querySelector('.gem-error-modal-card'), {
              scale: 0.8,
              opacity: 0,
              duration: 0.2,
              ease: "power2.in",
              onComplete: () => {
                dom.errorModal.style.display = 'none';
              }
            });
          } else {
            dom.errorModal.style.display = 'none';
          }
        }
      });
    }

    function resetPurchaseButtons() {
      if (dom.mainSubmitBtn) {
        dom.mainSubmitBtn.removeAttribute('disabled');
        dom.mainSubmitBtn.setAttribute('aria-disabled', 'false');
      }
      if (dom.buyBtnText) dom.buyBtnText.textContent = 'COMPLETA TU PACK';

      if (dom.buyBtnMobile) {
        dom.buyBtnMobile.classList.remove('disabled');
        dom.buyBtnMobile.setAttribute('aria-disabled', 'false');
        const mobSpan = dom.buyBtnMobile.querySelector('span');
        if (mobSpan) mobSpan.textContent = '¡PIDE YA TU PACK!';
      }
    }

    if (dom.mainForm) {
      dom.mainForm.addEventListener('submit', (e) => {
        e.preventDefault();

        if (dom.mainSubmitBtn) {
          dom.mainSubmitBtn.setAttribute('disabled', 'disabled');
          dom.mainSubmitBtn.setAttribute('aria-disabled', 'true');
        }
        if (dom.buyBtnText) dom.buyBtnText.textContent = 'PROCESANDO PACK...';

        if (dom.buyBtnMobile) {
          dom.buyBtnMobile.classList.add('disabled');
          dom.buyBtnMobile.setAttribute('aria-disabled', 'true');
          const mobSpan = dom.buyBtnMobile.querySelector('span');
          if (mobSpan) mobSpan.textContent = 'PROCESANDO...';
        }

        const formData = new FormData(dom.mainForm);
        const rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const cartAddUrl = rootPath + 'cart/add.js';

        fetch(cartAddUrl, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(async (response) => {
          const data = await response.json();
          if (response.ok) {
            window.location.href = '/checkout';
          } else {
            showErrorModal(
              "No se pudo crear tu pack en la tienda de Shopify.",
              data.description || data.message || "Es posible que los Variant IDs configurados en el administrador de Shopify no existan o no tengan inventario disponible."
            );
            resetPurchaseButtons();
          }
        })
        .catch(error => {
          console.error('Error adding pack to cart:', error);
          showErrorModal(
            "Hubo un fallo de conexión al intentar procesar tu pack.",
            error.message || "Verifica tu conexión a internet o la configuración del servidor de Shopify."
          );
          resetPurchaseButtons();
        });
      });
    }

    if (dom.buyBtnMobile) {
      dom.buyBtnMobile.addEventListener('click', (e) => {
        e.preventDefault();
        const total = Object.values(counts).reduce((a, b) => a + b, 0);
        if (total < currentPackSize) return;
        
        if (dom.mainSubmitBtn && !dom.mainSubmitBtn.disabled) {
          dom.mainSubmitBtn.click();
        }
      });
    }

    initMobileStickyDock();
    updateInterface();
    startAmbientBubbles();

    builder.addEventListener('shopify:section:unload', () => {
      if (typeof gsap !== 'undefined') {
        gsap.killTweensOf('*');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_pre-footer-section_dos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Declaración Defensiva de Inicialización de Secciones Animadas
    const prefooterSections = document.querySelectorAll('.gem-prefooter-wrapper[data-animate="true"]');
    
    if (prefooterSections.length === 0) return;

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn('[GEM-PreFooter] Librería GSAP o ScrollTrigger ausente globalmente en theme.liquid.');
      return;
    }

    // Inicializar el motor animado para cada sección autónoma
    prefooterSections.forEach(section => {
      const sectionId = section.dataset.sectionId;
      const animStyle = section.dataset.animStyle || 'reveal-split';
      const duration = parseFloat(section.dataset.animDuration) || 0.8;

      const colLeft = section.querySelector('.gem-prefooter-col-left');
      const colRight = section.querySelector('.gem-prefooter-col-right');
      const centerCard = section.querySelector('.gem-prefooter-center-card');

      const ctx = gsap.context(() => {
        // Soporte Absoluto a Modos de Movimiento Reducido (WCAG)
        const mm = gsap.matchMedia();
        mm.add({
          isDesktop: "(min-width: 768px)",
          isMobile: "(max-width: 767px)",
          reduceMotion: "(prefers-reduced-motion: reduce)"
        }, (context) => {
          const { reduceMotion, isDesktop } = context.conditions;
          if (reduceMotion) return; // Omitir si el usuario tiene activado reducción de movimiento

          if (animStyle === 'reveal-split' && isDesktop) {
            // Revelado de Cortina (Apertura sincronizada hacia afuera)
            const tl = gsap.timeline({
              scrollTrigger: {
                trigger: section,
                start: "top 80%",
                toggleActions: "play none none none"
              }
            });

            tl.from(colLeft, {
              xPercent: -20,
              autoAlpha: 0,
              duration: duration,
              ease: "power2.out"
            }, 0)
            .from(colRight, {
              xPercent: 20,
              autoAlpha: 0,
              duration: duration,
              ease: "power2.out"
            }, 0)
            .from(centerCard, {
              scale: 0.9,
              y: 20,
              autoAlpha: 0,
              duration: duration * 0.9,
              ease: "back.out(1.4)"
            }, "-=0.4");

          } else {
            // Animación Fade-Up Unificada (Soporta móvil o clásico)
            gsap.from([colLeft, centerCard, colRight], {
              y: 40,
              autoAlpha: 0,
              duration: duration,
              stagger: 0.15,
              ease: "power2.out",
              scrollTrigger: {
                trigger: section,
                start: "top 85%",
                toggleActions: "play none none none"
              }
            });
          }
        });
      }, section);

      // Desconexión limpia de memoria para optimizar el editor de temas de Shopify (evita fugas en renders dinámicos)
      section.addEventListener('shopify:section:unload', () => ctx.revert());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_showcase-section"] && !Shopify.designMode) return;
  try {
    
  // Arquitectura robusta v7.0

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_showcase-section_dos"] && !Shopify.designMode) return;
  try {
    
  /* =============================================
     JS ENCAPSULADO CON ANIMACIÓN GSAP INTERACTIVA
     ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const showcase = document.querySelector('.gem-showcase-section[data-section-id]');
    if (!showcase) return;

    const animEnabled = showcase.dataset.animate === 'true';
    const floatEnabled = showcase.dataset.floating === 'true';
    const bottleFloatEnabled = showcase.dataset.bottleFloat === 'true';

    const tabBtns = showcase.querySelectorAll('.gem-showcase-tab-btn');
    const panels = showcase.querySelectorAll('.gem-showcase-panel');
    const displayWrapper = showcase.querySelector('.gem-showcase-display-wrapper');

    let isMobile = window.matchMedia("(max-width: 991px)").matches;
    window.addEventListener('resize', () => {
      isMobile = window.matchMedia("(max-width: 991px)").matches;
    });

    // Variable para almacenar el timeline del balanceo de la botella activa
    let bottleTimeline = null;

    // Función para arrancar la flotación/balanceo continuo de la botella seleccionada
    const startBottleFloating = (bottleElement) => {
      if (!bottleFloatEnabled || typeof gsap === 'undefined' || !bottleElement) return;
      
      // Limpiamos cualquier animación previa que pueda colisionar
      gsap.killTweensOf(bottleElement);
      
      // Creamos un ciclo infinito muy natural y sutil
      bottleTimeline = gsap.timeline({ repeat: -1, yoyo: true });
      bottleTimeline.to(bottleElement, {
        y: -14,
        rotation: 2.5,
        duration: 3,
        ease: "sine.inOut"
      });
    };

    // Inicializar flotación para la primera botella visible al cargar
    const initialActivePanel = showcase.querySelector('.gem-showcase-panel.is-active');
    if (initialActivePanel) {
      const initialBottle = initialActivePanel.querySelector('.gem-panel-bottle-img');
      startBottleFloating(initialBottle);
    }

    // Lógica interactiva nativa de pestañas (Tabs) con corrección móvil
    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('aria-controls');
        const targetPanel = showcase.querySelector('#' + targetId);

        if (btn.classList.contains('is-active')) return;

        // 1. Alternar Clases Activas en Botones
        tabBtns.forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        // 2. Centrado suave del botón en móviles para mejor visibilidad del carrusel
        if (isMobile) {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }

        // 3. Aplicar cambio dinámico de color en el Wrapper
        const newTint = btn.dataset.tint;
        displayWrapper.style.setProperty('--active-bg-tint', newTint);

        // 4. Alternar Clases en Paneles de Contenido
        panels.forEach(p => p.classList.remove('is-active'));
        if (targetPanel) {
          targetPanel.classList.add('is-active');

          const bottle = targetPanel.querySelector('.gem-panel-bottle-img');
          const texts = targetPanel.querySelector('.gem-panel-text-side').children;
          const props = targetPanel.querySelectorAll('.gem-panel-prop');

          // Ejecutar Micro-animaciones de entrada con GSAP si está habilitado
          if (animEnabled && typeof gsap !== 'undefined') {
            if (bottleTimeline) bottleTimeline.kill(); // Matamos el loop anterior

            gsap.killTweensOf([bottle, texts, props]);

            // Animación Entrada Botella (Efecto Bouncy)
            gsap.fromTo(bottle, 
              { scale: 0.85, y: 30, opacity: 0, rotation: -4 }, 
              { 
                scale: 1, 
                y: 0, 
                opacity: 1, 
                rotation: 0,
                duration: 0.7, 
                ease: "back.out(1.5)",
                onComplete: () => {
                  // Tras finalizar la entrada, arranca el loop flotante infinito
                  startBottleFloating(bottle);
                }
              }
            );

            // Animación Stagger de Textos e Info Pills
            gsap.fromTo(texts,
              { opacity: 0, x: -25 },
              { opacity: 1, x: 0, duration: 0.55, stagger: 0.08, ease: "power2.out" }
            );

            // Animación Props Decorativos
            gsap.fromTo(props,
              { opacity: 0, scale: 0.6, rotation: (i) => i === 0 ? -15 : 15 },
              { opacity: 1, scale: 1, rotation: 0, duration: 0.8, delay: 0.15, stagger: 0.1, ease: "elastic.out(1, 0.75)" }
            );
          } else {
            // Fallback directo si no hay animaciones
            startBottleFloating(bottle);
          }
        }

        // 5. SOLUCIÓN UX MÓVIL CRÍTICA: Auto-focus scroll suave
        if (isMobile && displayWrapper) {
          // Calculamos el desfase con un margen superior de 100px para evitar colisión con el sticky header
          const wrapperTop = displayWrapper.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({
            top: wrapperTop,
            behavior: 'smooth'
          });
        }
      });
    });

    // Lógica de Flotación Continua en Gravedad Cero de Frutas (GSAP Premium Skill)
    if (animEnabled && floatEnabled && typeof gsap !== 'undefined') {
      const ctx = gsap.context(() => {
        panels.forEach(panel => {
          const propLeft = panel.querySelector('.gem-panel-prop-left');
          const propRight = panel.querySelector('.gem-panel-prop-right');

          if (propLeft) {
            gsap.to(propLeft, {
              y: isMobile ? -15 : -30,
              rotation: 10,
              duration: 3 + Math.random() * 2,
              repeat: -1,
              yoyo: true,
              ease: "sine.inOut"
            });
          }

          if (propRight) {
            gsap.to(propRight, {
              y: isMobile ? 15 : 30,
              rotation: -12,
              duration: 3.5 + Math.random() * 2,
              repeat: -1,
              yoyo: true,
              ease: "sine.inOut"
            });
          }
        });

        // 6. SOLUCIÓN SCROLLTRIGGER: Animación coordinada al entrar a la vista
        if (typeof ScrollTrigger !== 'undefined') {
          // Revelar encabezado
          gsap.from(".gem-showcase-header", {
            scrollTrigger: {
              trigger: showcase,
              start: "top 85%",
              toggleActions: "play none none none"
            },
            opacity: 0,
            y: 30,
            duration: 0.8,
            ease: "power2.out"
          });

          // Revelar pestañas
          gsap.from(".gem-showcase-tabs", {
            scrollTrigger: {
              trigger: ".gem-showcase-tabs",
              start: "top 90%",
              toggleActions: "play none none none"
            },
            opacity: 0,
            y: 20,
            duration: 0.6,
            ease: "power2.out"
          });

          // Revelar display de sabores
          gsap.from(".gem-showcase-display-wrapper", {
            scrollTrigger: {
              trigger: ".gem-showcase-display-wrapper",
              start: "top 85%",
              toggleActions: "play none none none"
            },
            opacity: 0,
            y: 40,
            duration: 0.8,
            ease: "power3.out"
          });
        }
      }, showcase);

      showcase.addEventListener('shopify:section:unload', () => ctx.revert());
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propio_showcase-section_tres"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================================
     JS ENCAPSULADO CON ANIMACIÓN DE TRANSICIÓN GSAP
     Gobernado por ScrollTrigger. Sin interpolaciones Liquid.
     ========================================================================== */
  document.addEventListener('DOMContentLoaded', () => {
    const sectionWrapper = document.querySelector('.shsk-v10-showcase-wrapper[data-section-id]');
    if (!sectionWrapper) return;

    const animateEnabled = sectionWrapper.dataset.animate === 'true';
    const durationSec = parseFloat(sectionWrapper.dataset.duration) || 0.8;
    const easingType = sectionWrapper.dataset.ease || 'power2.out';
    const baseBg = sectionWrapper.dataset.bgBase || '#fdfbf7';

    // Guard-Clause para el motor de animaciones
    if (typeof gsap === 'undefined') {
      console.warn('[GEM] GSAP no está definido. Los colores y el contenido utilizarán fallbacks CSS nativos.');
      return;
    }

    const rows = sectionWrapper.querySelectorAll('.shsk-v10-row');
    const totalRows = rows.length;

    // MATCHMEDIA: Respetar la directiva nativa de movimiento reducido en el sistema operativo
    const mm = gsap.matchMedia();
    mm.add({
      reduceMotion: "(prefers-reduced-motion: reduce)",
      allowMotion: "(prefers-reduced-motion: no-preference)"
    }, (context) => {
      
      // LÓGICA DE DETECCIÓN DE SCROLL (Siempre activa para la transición cromática de fondo)
      rows.forEach((row, index) => {
        const bgTint = row.dataset.bgTint;
        const isFirst = index === 0;
        const isLast = index === totalRows - 1;

        gsap.timeline({
          scrollTrigger: {
            trigger: row,
            start: "top 60%",
            end: "bottom 40%",
            toggleActions: "play none none reverse",
            onEnter: () => gsap.to(sectionWrapper, { backgroundColor: bgTint, duration: 0.6, ease: "power2.out" }),
            onEnterBack: () => gsap.to(sectionWrapper, { backgroundColor: bgTint, duration: 0.6, ease: "power2.out" }),
            onLeave: () => {
              if (isLast) {
                gsap.to(sectionWrapper, { backgroundColor: baseBg, duration: 0.6, ease: "power2.out" });
              }
            },
            onLeaveBack: () => {
              if (isFirst) {
                gsap.to(sectionWrapper, { backgroundColor: baseBg, duration: 0.6, ease: "power2.out" });
              }
            }
          }
        });

        // Solo ejecutar transiciones cinéticas complejas si el cliente lo permite en su S.O. y Schema
        if (context.conditions.allowMotion && animateEnabled) {
          
          const artwork = row.querySelector('.shsk-v10-animal-artwork');
          const bottle = row.querySelector('.shsk-v10-bottle-wrapper');
          const props = row.querySelectorAll('.shsk-v10-prop');
          const content = row.querySelector('.shsk-v10-content');
          const ripples = row.querySelectorAll('.shsk-v10-ripple');

          // Revelaciones Dinámicas al entrar al viewport
          const introTl = gsap.timeline({
            scrollTrigger: {
              trigger: row,
              start: "top 75%",
              toggleActions: "play none none reverse"
            }
          });

          if (artwork) {
            introTl.fromTo(artwork, 
              { scale: 0.85, opacity: 0 }, 
              { scale: 1, opacity: 1, duration: durationSec, ease: easingType }, 
              0
            );
          }

          if (bottle) {
            introTl.fromTo(bottle, 
              { y: 60, opacity: 0 }, 
              { y: 0, opacity: 1, duration: durationSec, ease: "power3.out" }, 
              0.1
            );
          }

          if (content) {
            const isEven = Array.from(rows).indexOf(row) % 2 === 1;
            introTl.fromTo(content, 
              { x: isEven ? 30 : -30, opacity: 0 }, 
              { x: 0, opacity: 1, duration: durationSec, ease: "power2.out" }, 
              0.2
            );
          }

          // IMPACTO LÍQUIDO (Splash Stagger): Onda explosiva neobrutalista al entrar al viewport
          if (ripples.length) {
            introTl.fromTo(ripples,
              { scale: 0.2, opacity: 0 },
              { scale: 1.1, opacity: 0.35, duration: 1.4, stagger: 0.15, ease: "power2.out" },
              0.15
            );
          }

          // Efecto de cabeceo rotativo sutil en la botella guiado por el Scroll
          if (bottle) {
            gsap.fromTo(bottle,
              { rotate: -3 },
              {
                rotate: 3,
                scrollTrigger: {
                  trigger: row,
                  start: "top bottom",
                  end: "bottom top",
                  scrub: true
                }
              }
            );
          }

          // Loop ambiente infinito de props flotantes (Con cabeceo tridimensional)
          props.forEach((prop, i) => {
            gsap.to(prop, {
              y: i % 2 === 0 ? -15 : 15,
              rotate: i % 2 === 0 ? -10 : 10,
              duration: 3.0 + (i * 0.8),
              repeat: -1,
              yoyo: true,
              ease: "sine.inOut"
            });
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
